angular.module("LeasePilot").controller("ReportsIndexController", [
  "$scope",
  "$window",
  "$timeout",
  "ReportsUiService",
  function ReportsIndexController($scope, $window, $timeout, ReportsUiService) {
    var vm = this;

    vm.savedReports = [];
    vm.savedSort = "recent";
    vm.savedLoading = true;
    vm.savedError = "";
    vm.toastMessage = "";
    vm.toastVisible = false;
    vm.toastType = "success";

    var toastTimeoutPromise = null;
    var REPORT_PENDING_STATE_STORAGE_PREFIX = "leasepilot.reports.pendingState.";

    vm.renameModalOpen = false;
    vm.deleteModalOpen = false;
    vm.modalTarget = null;
    vm.renameValue = "";
    vm.renameModalError = "";
    vm.duplicatingId = null;

    vm.documentTypeOptions = [];
    vm.availableForms = [];
    vm.mentionData = { buildings: [], users: [], fields: [] };
    vm.columnOptions = [];
    vm.filteredFormOptionsView = [];
    vm.groupedColumnOptionsView = [];
    vm.filteredUserOptionsView = [];
    vm.groupedFilteredUserOptionsView = [];
    vm.filteredBuildingOptionsView = [];
    vm.dateYearOptions = [];
    vm.dateQuarterOptions = [];
    vm.dateMonthOptions = [];
    vm.standardColumnsView = [];
    vm.operatorOptionsByType = {
      string: [
        { id: "eq", name: "=" },
        { id: "neq", name: "!=" },
        { id: "contains", name: "Contains" },
        { id: "starts_with", name: "Starts with" },
        { id: "ends_with", name: "Ends with" },
        { id: "empty", name: "Is empty" },
        { id: "not_empty", name: "Is not empty" }
      ],
      number: [
        { id: "eq", name: "=" },
        { id: "neq", name: "!=" },
        { id: "gt", name: ">" },
        { id: "gte", name: ">=" },
        { id: "lt", name: "<" },
        { id: "lte", name: "<=" },
        { id: "empty", name: "Is empty" },
        { id: "not_empty", name: "Is not empty" }
      ],
      date: [
        { id: "eq", name: "On" },
        { id: "neq", name: "Not on" },
        { id: "gt", name: "After" },
        { id: "gte", name: "On or after" },
        { id: "lt", name: "Before" },
        { id: "lte", name: "On or before" },
        { id: "empty", name: "Is empty" },
        { id: "not_empty", name: "Is not empty" }
      ],
      boolean: [
        { id: "eq", name: "Is" },
        { id: "neq", name: "Is not" },
        { id: "empty", name: "Is empty" },
        { id: "not_empty", name: "Is not empty" }
      ]
    };
    vm.wizard = defaultWizardState();
    vm.promptDropdownOpen = false;
    vm.promptDropdownItems = [];
    vm.promptHighlightedIndex = -1;
    vm.promptMentionStartPos = -1;
    vm.promptMentionCursorPos = -1;

    vm.init = function init() {
      loadSavedReports();
      loadWizardOptions();
      refreshDerivedFilterLists();
    };

    vm.onPromptInput = function onPromptInput(event) {
      var target =
        (event && event.target) ||
        document.getElementById("report-prompt-input") ||
        document.activeElement;
      updatePromptMentionDropdown(target);
    };

    vm.onPromptKeydown = function onPromptKeydown(event) {
      if (!vm.promptDropdownOpen) return;
      if (event.key === "ArrowDown") {
        event.preventDefault();
        vm.promptHighlightedIndex = Math.min(
          vm.promptDropdownItems.length - 1,
          vm.promptHighlightedIndex + 1
        );
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        vm.promptHighlightedIndex = Math.max(0, vm.promptHighlightedIndex - 1);
      } else if (
        (event.key === "Enter" || event.key === "Tab") &&
        vm.promptHighlightedIndex >= 0
      ) {
        event.preventDefault();
        vm.selectPromptMention(
          vm.promptDropdownItems[vm.promptHighlightedIndex]
        );
      } else if (event.key === "Escape") {
        closePromptMentionDropdown();
      }
    };

    vm.hidePromptMentionDropdown = function hidePromptMentionDropdown() {
      window.setTimeout(function() {
        closePromptMentionDropdown();
      }, 120);
    };

    vm.selectPromptMention = function selectPromptMention(item) {
      if (!item) return;
      var input = document.getElementById("report-prompt-input");
      var text = vm.wizard.editedPrompt || "";
      var start = vm.promptMentionStartPos;
      var end = vm.promptMentionCursorPos;
      if (start < 0 || end < 0 || start > end) return;
      var insertion = "@" + item.name;
      vm.wizard.editedPrompt =
        text.substring(0, start) + insertion + " " + text.substring(end);
      closePromptMentionDropdown();
      window.setTimeout(function() {
        if (!input) return;
        var nextPos = start + insertion.length + 1;
        input.focus();
        input.setSelectionRange(nextPos, nextPos);
      }, 0);
    };

    vm.stepTitle = function stepTitle(step) {
      var titles = [
        "Document types",
        "Data",
        "Time",
        "Users",
        "Buildings",
        "Conditions"
      ];
      return titles[step] || "";
    };

    vm.selectDocumentType = function selectDocumentType(typeId) {
      if (!typeId) return;
      var idx = vm.wizard.documentTypes.indexOf(typeId);
      if (idx >= 0) {
        vm.wizard.documentTypes.splice(idx, 1);
      } else {
        vm.wizard.documentTypes.push(typeId);
      }
      pruneSelectedFormsByDocumentTypes();
    };

    vm.isDocTypeSelected = function isDocTypeSelected(typeId) {
      return vm.wizard.documentTypes.indexOf(typeId) >= 0;
    };

    vm.onColumnModeChange = function onColumnModeChange() {
      if (vm.wizard.columnMode === "standard") vm.wizard.additionalColumns = [];
    };

    vm.toggleAdditionalColumn = function toggleAdditionalColumn(columnId) {
      if (!columnId) return;
      var idx = vm.wizard.additionalColumns.indexOf(columnId);
      if (idx >= 0) vm.wizard.additionalColumns.splice(idx, 1);
      else vm.wizard.additionalColumns.push(columnId);
    };

    vm.hasAdditionalColumn = function hasAdditionalColumn(columnId) {
      return vm.wizard.additionalColumns.indexOf(columnId) >= 0;
    };

    // -- Cached pill arrays (avoid new-object-per-digest causing infdig) --
    var _columnPillsCache = { key: '', pills: [] };
    vm.selectedColumnPills = function selectedColumnPills() {
      var key = (vm.wizard.additionalColumns || []).join(',');
      if (key === _columnPillsCache.key) return _columnPillsCache.pills;
      _columnPillsCache.key = key;
      _columnPillsCache.pills = !key ? [] : vm.wizard.additionalColumns.map(function(id) {
        var col = (vm.columnOptions || []).find(function(c) { return String(c.id) === String(id); });
        return { id: id, name: col ? (col.name || String(id)) : String(id) };
      });
      return _columnPillsCache.pills;
    };

    vm.removeAdditionalColumn = function removeAdditionalColumn(columnId) {
      var idx = vm.wizard.additionalColumns.indexOf(columnId);
      if (idx >= 0) vm.wizard.additionalColumns.splice(idx, 1);
    };

    var _docTypePillsCache = { key: '', pills: [] };
    vm.selectedDocTypePills = function selectedDocTypePills() {
      var key = (vm.wizard.documentTypes || []).join(',');
      if (key === _docTypePillsCache.key) return _docTypePillsCache.pills;
      _docTypePillsCache.key = key;
      _docTypePillsCache.pills = !key ? [] : vm.wizard.documentTypes.map(function(id) {
        var dt = (vm.documentTypeOptions || []).find(function(d) { return String(d.id) === String(id); });
        return { id: id, name: dt ? (dt.name || String(id)) : String(id) };
      });
      return _docTypePillsCache.pills;
    };

    vm.removeDocumentType = function removeDocumentType(typeId) {
      var idx = vm.wizard.documentTypes.indexOf(typeId);
      if (idx >= 0) {
        vm.wizard.documentTypes.splice(idx, 1);
        pruneSelectedFormsByDocumentTypes();
      }
    };

    var _buildingPillsCache = { key: '', pills: [] };
    vm.selectedBuildingPills = function selectedBuildingPills() {
      var key = (vm.wizard.buildingIds || []).join(',');
      if (key === _buildingPillsCache.key) return _buildingPillsCache.pills;
      _buildingPillsCache.key = key;
      _buildingPillsCache.pills = !key ? [] : vm.wizard.buildingIds.map(function(id) {
        var b = (vm.mentionData.buildings || []).find(function(item) { return String(item.id) === String(id); });
        return { id: id, name: b ? (b.name || String(id)) : String(id) };
      });
      return _buildingPillsCache.pills;
    };

    vm.removeBuildingPill = function removeBuildingPill(id) {
      var idx = vm.wizard.buildingIds.indexOf(String(id));
      if (idx >= 0) vm.wizard.buildingIds.splice(idx, 1);
    };

    var _userPillsCache = { key: '', pills: [] };
    vm.selectedUserPills = function selectedUserPills() {
      var key = (vm.wizard.userIds || []).join(',');
      if (key === _userPillsCache.key) return _userPillsCache.pills;
      _userPillsCache.key = key;
      _userPillsCache.pills = !key ? [] : vm.wizard.userIds.map(function(id) {
        var label = labelsFromIds([id], vm.mentionData.users)[0] || String(id);
        return { id: id, name: label };
      });
      return _userPillsCache.pills;
    };

    vm.removeUserPill = function removeUserPill(id) {
      var idx = vm.wizard.userIds.indexOf(String(id));
      if (idx >= 0) vm.wizard.userIds.splice(idx, 1);
    };

    var _formPillsCache = { key: '', pills: [] };
    vm.selectedFormPills = function selectedFormPills() {
      var key = (vm.wizard.formIds || []).join(',');
      if (key === _formPillsCache.key) return _formPillsCache.pills;
      _formPillsCache.key = key;
      _formPillsCache.pills = !key ? [] : vm.wizard.formIds.map(function(id) {
        var f = (vm.availableForms || []).find(function(item) { return String(item.id) === String(id); });
        return { id: id, name: f ? (f.label || f.name || String(id)) : String(id) };
      });
      return _formPillsCache.pills;
    };

    vm.removeFormPill = function removeFormPill(id) {
      var idx = vm.wizard.formIds.indexOf(String(id));
      if (idx >= 0) vm.wizard.formIds.splice(idx, 1);
    };

    vm.filteredColumnOptions = function filteredColumnOptions() {
      var query = (vm.wizard.columnSearch || "").toLowerCase().trim();
      if (!query) return vm.columnOptions;
      return vm.columnOptions.filter(function(field) {
        return (
          (field.name || "").toLowerCase().indexOf(query) >= 0 ||
          (field.id || "").toLowerCase().indexOf(query) >= 0 ||
          (field.category || "").toLowerCase().indexOf(query) >= 0
        );
      });
    };

    vm.groupedFilteredColumnOptions = function groupedFilteredColumnOptions() {
      var filtered = vm.filteredColumnOptions();
      var grouped = {};
      filtered.forEach(function(field) {
        var category = field.category || "Other";
        if (!grouped[category]) grouped[category] = [];
        grouped[category].push(field);
      });

      return Object.keys(grouped)
        .sort(function(a, b) {
          return a.localeCompare(b);
        })
        .map(function(category) {
          grouped[category].sort(function(a, b) {
            return (a.name || "").localeCompare(b.name || "");
          });
          return { category: category, fields: grouped[category] };
        });
    };

    vm.filteredBuildingOptions = function filteredBuildingOptions() {
      var query = (vm.wizard.buildingSearch || "").toLowerCase().trim();
      var buildings = vm.mentionData.buildings || [];
      if (!query) return buildings;
      return buildings.filter(function(building) {
        var name = (building.name || "").toLowerCase();
        var id = String(building.id || "").toLowerCase();
        return name.indexOf(query) >= 0 || id.indexOf(query) >= 0;
      });
    };

    vm.filteredUserOptions = function filteredUserOptions() {
      var query = (vm.wizard.userSearch || "").toLowerCase().trim();
      var users = vm.mentionData.users || [];
      if (!query) return users;
      return users.filter(function(user) {
        var name = (user.name || user.label || "").toLowerCase();
        var email = (user.email || "").toLowerCase();
        var id = String(user.id || "").toLowerCase();
        return (
          name.indexOf(query) >= 0 ||
          email.indexOf(query) >= 0 ||
          id.indexOf(query) >= 0
        );
      });
    };

    vm.setDatePreset = function setDatePreset(preset) {
      if (vm.wizard.datePreset === preset) {
        vm.wizard.datePreset = "none";
        vm.wizard.dateFrom = "";
        vm.wizard.dateTo = "";
        return;
      }

      vm.wizard.datePreset = preset;
      if (preset === "none") {
        vm.wizard.dateFrom = "";
        vm.wizard.dateTo = "";
        return;
      }

      var today = new Date();
      var from = new Date(today.getTime());
      var to = new Date(today.getTime());

      var yearMatch = String(preset).match(/^year_(\d{4})$/);
      var quarterMatch = String(preset).match(/^quarter_(\d{4})_q([1-4])$/);
      var monthMatch = String(preset).match(/^month_(\d{4})_(\d{2})$/);

      if (yearMatch) {
        var year = Number(yearMatch[1]);
        from = new Date(year, 0, 1);
        to = new Date(year, 11, 31);
      } else if (quarterMatch) {
        var quarterYear = Number(quarterMatch[1]);
        var quarter = Number(quarterMatch[2]);
        var quarterStartMonth = (quarter - 1) * 3;
        from = new Date(quarterYear, quarterStartMonth, 1);
        to = new Date(quarterYear, quarterStartMonth + 3, 0);
      } else if (monthMatch) {
        var monthYear = Number(monthMatch[1]);
        var month = Number(monthMatch[2]) - 1;
        from = new Date(monthYear, month, 1);
        to = new Date(monthYear, month + 1, 0);
      } else if (preset === "last_30_days") {
        from.setDate(today.getDate() - 30);
      } else if (preset === "last_90_days") {
        from.setDate(today.getDate() - 90);
      } else if (preset === "ytd") {
        from = new Date(today.getFullYear(), 0, 1);
      } else if (preset === "q1") {
        from = new Date(today.getFullYear(), 0, 1);
        to = new Date(today.getFullYear(), 2, 31);
      } else if (preset === "q2") {
        from = new Date(today.getFullYear(), 3, 1);
        to = new Date(today.getFullYear(), 5, 30);
      } else if (preset === "q3") {
        from = new Date(today.getFullYear(), 6, 1);
        to = new Date(today.getFullYear(), 8, 30);
      } else if (preset === "q4") {
        from = new Date(today.getFullYear(), 9, 1);
        to = new Date(today.getFullYear(), 11, 31);
      } else if (preset === "custom") {
        return;
      }

      vm.wizard.dateFrom = toIsoDate(from);
      vm.wizard.dateTo = toIsoDate(to);
    };

    vm.toggleUser = function toggleUser(userId) {
      toggleInArray(vm.wizard.userIds, String(userId));
    };

    vm.toggleBuilding = function toggleBuilding(buildingId) {
      toggleInArray(vm.wizard.buildingIds, String(buildingId));
    };

    vm.selectAllUsers = function selectAllUsers() {
      vm.wizard.userIds = (vm.mentionData.users || []).map(function(user) {
        return String(user.id);
      });
    };

    vm.isGroupFullySelected = function isGroupFullySelected(grp) {
      if (!grp || !grp.users || !grp.users.length) return false;
      var ids = vm.wizard.userIds || [];
      return grp.users.every(function(u) {
        return ids.indexOf(String(u.id)) >= 0;
      });
    };

    vm.toggleUsersInGroup = function toggleUsersInGroup(grp) {
      if (!grp || !grp.users || !grp.users.length) return;
      var ids = vm.wizard.userIds || [];
      var groupIds = grp.users.map(function(u) {
        return String(u.id);
      });
      var allSelected = groupIds.every(function(id) {
        return ids.indexOf(id) >= 0;
      });
      if (allSelected) {
        vm.wizard.userIds = ids.filter(function(id) {
          return groupIds.indexOf(id) < 0;
        });
      } else {
        var merged = ids.slice();
        groupIds.forEach(function(id) {
          if (merged.indexOf(id) < 0) merged.push(id);
        });
        vm.wizard.userIds = merged;
      }
    };

    vm.clearUsers = function clearUsers() {
      vm.wizard.userIds = [];
    };

    vm.selectAllBuildings = function selectAllBuildings() {
      vm.wizard.buildingIds = (vm.mentionData.buildings || []).map(function(
        building
      ) {
        return String(building.id);
      });
    };

    vm.clearBuildings = function clearBuildings() {
      vm.wizard.buildingIds = [];
    };

    vm.toggleForm = function toggleForm(formId) {
      toggleInArray(vm.wizard.formIds, String(formId));
    };

    vm.selectAllForms = function selectAllForms() {
      vm.wizard.formIds = formsMatchingSelectedDocumentTypes().map(function(
        form
      ) {
        return String(form.id);
      });
    };

    vm.clearForms = function clearForms() {
      vm.wizard.formIds = [];
    };

    vm.filteredFormOptions = function filteredFormOptions() {
      var formsByType = formsMatchingSelectedDocumentTypes();
      var query = (vm.wizard.formSearch || "").toLowerCase().trim();
      if (!query) return formsByType;
      return formsByType.filter(function(form) {
        return (
          (form.label || "").toLowerCase().indexOf(query) >= 0 ||
          (form.name || "").toLowerCase().indexOf(query) >= 0 ||
          (form.flavor || "").toLowerCase().indexOf(query) >= 0 ||
          (form.deal_type || "").toLowerCase().indexOf(query) >= 0
        );
      });
    };

    vm.addCondition = function addCondition() {
      vm.wizard.conditions.push({
        field_id: "",
        field_name: "",
        field_query: "",
        operator: "eq",
        value: "",
        value_type: "string",
        showFieldSuggestions: false
      });
    };

    vm.removeCondition = function removeCondition(index) {
      vm.wizard.conditions.splice(index, 1);
    };

    vm.onConditionFieldChange = function onConditionFieldChange(condition) {
      var selected = vm.columnOptions.find(function(field) {
        return field.id === condition.field_id;
      });
      condition.field_name = selected ? selected.name : "";
      condition.field_query = selected
        ? selected.name + " (" + selected.id + ")"
        : "";
      condition.value_type =
        selected && selected.value_type ? selected.value_type : "string";
      ensureValidOperatorForCondition(condition);
    };

    vm.filteredConditionFieldOptions = function filteredConditionFieldOptions(
      condition
    ) {
      if (!condition) return vm.columnOptions.slice(0, 30);
      var query = (condition.field_query || "").toLowerCase().trim();
      if (!query) return vm.columnOptions.slice(0, 30);
      return vm.columnOptions
        .filter(function(field) {
          return (
            (field.name || "").toLowerCase().indexOf(query) >= 0 ||
            (field.id || "").toLowerCase().indexOf(query) >= 0 ||
            (field.category || "").toLowerCase().indexOf(query) >= 0
          );
        })
        .slice(0, 30);
    };

    vm.selectConditionFieldSuggestion = function selectConditionFieldSuggestion(
      condition,
      field
    ) {
      if (!condition || !field) return;
      condition.field_id = field.id;
      condition.field_name = field.name || field.id;
      condition.field_query = (field.name || field.id) + " (" + field.id + ")";
      condition.value_type = field.value_type || "string";
      condition.showFieldSuggestions = false;
      ensureValidOperatorForCondition(condition);
    };

    vm.operatorOptionsForCondition = function operatorOptionsForCondition(
      condition
    ) {
      var typeKey =
        condition && condition.value_type
          ? String(condition.value_type).toLowerCase()
          : "string";
      return (
        vm.operatorOptionsByType[typeKey] || vm.operatorOptionsByType.string
      );
    };

    vm.conditionValueIsBoolean = function conditionValueIsBoolean(condition) {
      return (
        condition &&
        String(condition.value_type || "").toLowerCase() === "boolean"
      );
    };

    vm.conditionValueDisabled = function conditionValueDisabled(condition) {
      return (
        condition &&
        (condition.operator === "empty" || condition.operator === "not_empty")
      );
    };

    vm.showConditionFieldSuggestions = function showConditionFieldSuggestions(
      condition
    ) {
      if (!condition) return;
      condition.showFieldSuggestions = true;
    };

    vm.hideConditionFieldSuggestions = function hideConditionFieldSuggestions(
      condition
    ) {
      if (!condition) return;
      condition.showFieldSuggestions = false;
    };

    function buildConditionExampleRow(fieldId, fallbackName, operator, value, valueType) {
      var field = (vm.columnOptions || []).find(function(f) {
        return f.id === fieldId;
      });
      var name = field ? field.name || field.id : fallbackName;
      var vt =
        field && field.value_type ? field.value_type : valueType;
      return {
        field_id: fieldId,
        field_name: name,
        field_query: name + " (" + fieldId + ")",
        operator: operator,
        value: String(value),
        value_type: vt,
        showFieldSuggestions: false
      };
    }

    /** FieldRegistry: baseRent, annualIncrease */
    vm.applyExampleConditionsDealTerms = function applyExampleConditionsDealTerms() {
      vm.wizard.conditions = [
        buildConditionExampleRow("baseRent", "Base Rent", "gt", "20", "number"),
        buildConditionExampleRow(
          "annualIncrease",
          "Annual Increase (%)",
          "gt",
          "3",
          "number"
        )
      ];
      vm.wizard.conditions.forEach(function(c) {
        ensureValidOperatorForCondition(c);
      });
      refreshDerivedFilterLists();
    };

    /** FieldRegistry: premiseAreaSize, leaseYears */
    vm.applyExampleConditionsPremiseAndTerm =
      function applyExampleConditionsPremiseAndTerm() {
        vm.wizard.conditions = [
          buildConditionExampleRow(
            "premiseAreaSize",
            "Premise Area (SF)",
            "gt",
            "10000",
            "number"
          ),
          buildConditionExampleRow(
            "leaseYears",
            "Lease Term (Years)",
            "gte",
            "10",
            "number"
          )
        ];
        vm.wizard.conditions.forEach(function(c) {
          ensureValidOperatorForCondition(c);
        });
        refreshDerivedFilterLists();
      };

    function groupUsersForFilterView(users) {
      users = users || [];
      if (users.length === 0) return [];
      var hasAnyGroup = false;
      for (var i = 0; i < users.length; i++) {
        var u = users[i];
        if (
          (u.group_key != null && u.group_key !== "") ||
          (u.groupKey != null && u.groupKey !== "")
        ) {
          hasAnyGroup = true;
          break;
        }
      }
      if (!hasAnyGroup) {
        return [
          { groupKey: "_all", groupLabel: "Users", users: users.slice() }
        ];
      }
      var buckets = {};
      users.forEach(function(u) {
        var key =
          u.group_key != null && u.group_key !== ""
            ? String(u.group_key)
            : u.groupKey != null && u.groupKey !== ""
              ? String(u.groupKey)
              : "_other";
        var label = u.group_label || u.groupLabel || "Users";
        if (!buckets[key]) {
          buckets[key] = { groupKey: key, groupLabel: label, users: [] };
        }
        buckets[key].users.push(u);
      });
      var keys = Object.keys(buckets);
      keys.sort(function(a, b) {
        if (a === "company") return -1;
        if (b === "company") return 1;
        return buckets[a].groupLabel.localeCompare(buckets[b].groupLabel);
      });
      return keys.map(function(k) {
        return buckets[k];
      });
    }

    function refreshDerivedFilterLists() {
      if (!vm.wizard) return;
      vm.filteredFormOptionsView = vm.filteredFormOptions();
      vm.groupedColumnOptionsView = vm.groupedFilteredColumnOptions();
      var filteredUsers = vm.filteredUserOptions();
      vm.filteredUserOptionsView = filteredUsers;
      vm.groupedFilteredUserOptionsView = groupUsersForFilterView(filteredUsers);
      vm.filteredBuildingOptionsView = vm.filteredBuildingOptions();
      (vm.wizard.conditions || []).forEach(function(c) {
        c._conditionFieldOptionsView = vm.filteredConditionFieldOptions(c);
      });
    }

    $scope.$watch(
      function reportsIndexFilterListDeps() {
        if (!vm.wizard) return "";
        return [
          vm.wizard.columnSearch,
          vm.wizard.formSearch,
          vm.wizard.userSearch,
          vm.wizard.buildingSearch,
          (vm.wizard.documentTypes || [])
            .slice()
            .sort()
            .join(","),
          (vm.columnOptions || []).length,
          (vm.mentionData.users || []).length,
          (vm.wizard.conditions || [])
            .map(function(c) {
              return (c.field_query || "") + "\t" + (c.field_id || "");
            })
            .join(";")
        ].join("\u0001");
      },
      function() {
        refreshDerivedFilterLists();
      }
    );

    vm.goToStep = function goToStep(step) {
      var target = Number(step);
      if (isNaN(target) || target < 0 || target > 6) return;
      if (target === 6) {
        ensurePromptReviewState();
      }
      vm.wizard.step = target;
      vm.wizard.error = "";
    };

    vm.canContinue = function canContinue() {
      return !stepValidationError(vm.wizard.step);
    };

    vm.nextStep = function nextStep() {
      var error = stepValidationError(vm.wizard.step);
      if (error) {
        vm.wizard.error = error;
        return;
      }
      var currentStep = Number(vm.wizard.step) || 0;
      if (currentStep === 5) {
        ensurePromptReviewState();
      }
      vm.wizard.error = "";
      vm.wizard.step = Math.min(6, currentStep + 1);
    };

    vm.prevStep = function prevStep() {
      vm.wizard.error = "";
      var currentStep = Number(vm.wizard.step) || 0;
      vm.wizard.step = Math.max(0, currentStep - 1);
    };

    vm.skipPromptReview = function skipPromptReview() {
      vm.wizard.editedPrompt = vm.wizard.generatedPrompt;
      vm.submitWizard();
    };

    vm.submitWizard = function submitWizard() {
      var finalSnapshot = snapshotFromWizard();
      var reportType = "results";
      var generatedPrompt =
        vm.wizard.generatedPrompt || buildPromptFromWizard();
      var editedPrompt = (vm.wizard.editedPrompt || "").trim();
      var generatedPromptTrimmed = (generatedPrompt || "").trim();
      var promptChanged =
        editedPrompt && editedPrompt !== generatedPromptTrimmed;

      persistPendingReportState(
        reportType,
        buildPendingReportState(reportType, finalSnapshot, {
          generatedPrompt: generatedPrompt,
          editedPrompt: editedPrompt,
          promptChanged: promptChanged
        })
      );

      $window.location.href =
        "/reports?report_type=" +
        encodeURIComponent(reportType) +
        "&auto_run=1";
    };

    vm.sortedSavedReports = function sortedSavedReports() {
      var reports = vm.savedReports.slice();
      if (vm.savedSort === "az") {
        reports.sort(function(a, b) {
          return (a.name || "").localeCompare(b.name || "");
        });
      } else {
        reports.sort(function(a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }
      return reports;
    };

    vm.reportTypeLabel = function reportTypeLabel(type) {
      if (!type) return "Leasing Activity";
      return "Leasing Activity";
    };

    vm.runSavedReportHref = function runSavedReportHref(report) {
      return "/reports?report_type=results&saved_report_id=" + report.id;
    };

    vm.openRenameModal = function openRenameModal(report) {
      vm.modalTarget = report;
      vm.renameValue = report.name || "";
      vm.renameModalError = "";
      vm.renameModalOpen = true;
      focusInputById("rename-report-name-input");
    };

    vm.confirmRename = function confirmRename() {
      if (!vm.modalTarget || !vm.renameValue || !vm.renameValue.trim()) {
        vm.renameModalError = "Please enter a report name.";
        focusInputById("rename-report-name-input");
        return;
      }
      vm.renameModalError = "";
      ReportsUiService.renameSavedReport(
        vm.modalTarget.id,
        vm.renameValue.trim()
      )
        .then(function() {
          vm.modalTarget.name = vm.renameValue.trim();
          vm.renameModalError = "";
          vm.renameModalOpen = false;
          showToast("Saved report renamed.", "success");
        })
        .catch(function(err) {
          vm.renameModalError = apiErrorMessage(
            err,
            "Could not rename saved report."
          );
        });
    };

    vm.openDeleteModal = function openDeleteModal(report) {
      vm.modalTarget = report;
      vm.deleteModalOpen = true;
    };

    vm.confirmDelete = function confirmDelete() {
      if (!vm.modalTarget) return;
      ReportsUiService.deleteSavedReport(vm.modalTarget.id)
        .then(function() {
          vm.savedReports = vm.savedReports.filter(function(r) {
            return r.id !== vm.modalTarget.id;
          });
          vm.deleteModalOpen = false;
          showToast("Saved report deleted.", "success");
        })
        .catch(function() {
          vm.savedError = "Could not delete saved report.";
        });
    };

    vm.duplicateSavedReport = function duplicateSavedReport(report) {
      if (!report || !report.id) return;
      vm.duplicatingId = report.id;
      vm.savedError = "";
      ReportsUiService.duplicateSavedReport(report.id)
        .then(function() {
          showToast("Saved report duplicated.", "success");
          loadSavedReports();
        })
        .catch(function(err) {
          vm.savedError = apiErrorMessage(
            err,
            "Could not duplicate saved report."
          );
        })
        .finally(function() {
          vm.duplicatingId = null;
        });
    };

    vm.closeModals = function closeModals() {
      vm.renameModalOpen = false;
      vm.deleteModalOpen = false;
      vm.modalTarget = null;
      vm.renameModalError = "";
    };

    vm.resetWizard = function resetWizard() {
      vm.wizard = defaultWizardState();
    };

    function defaultWizardState() {
      return {
        step: 0,
        error: "",
        documentTypes: [],
        columnMode: "standard",
        additionalColumns: [],
        columnSearch: "",
        useSpecificForms: false,
        formIds: [],
        formSearch: "",
        datePreset: "none",
        dateFrom: "",
        dateTo: "",
        userIds: [],
        userSearch: "",
        buildingIds: [],
        buildingSearch: "",
        conditions: [],
        generatedPrompt: "",
        editedPrompt: "",
        parsingPrompt: false,
        promptParseResult: null,
        previewBefore: null,
        previewAfter: null
      };
    }

    function pendingReportStateStorageKey(reportType) {
      return (
        REPORT_PENDING_STATE_STORAGE_PREFIX + String(reportType || "results")
      );
    }

    function persistPendingReportState(reportType, state) {
      writeSessionStorageJson(pendingReportStateStorageKey(reportType), state);
    }

    function writeSessionStorageJson(key, value) {
      try {
        if (!$window.sessionStorage || !key) return;
        if (value == null) {
          $window.sessionStorage.removeItem(key);
          return;
        }
        $window.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    }

    function buildPendingReportState(reportType, snapshot, options) {
      options = options || {};
      return {
        report_type: reportType,
        explicit_date_preset: snapshot.date_preset || "",
        filters: {
          date_from: snapshot.date_from || "",
          date_to: snapshot.date_to || "",
          building_ids: (snapshot.building_ids || []).slice(),
          form_ids: (snapshot.form_ids || []).slice(),
          document_types: (snapshot.document_types || []).slice(),
          created_by_user_ids: (snapshot.user_ids || []).slice()
        },
        columns: (snapshot.columns || []).slice(),
        conditions: (snapshot.conditions || []).map(function(condition) {
          return {
            field_id: condition.field_id,
            field_name: condition.field_name,
            operator: condition.operator,
            value: condition.value,
            value_type: condition.value_type
          };
        }),
        generated_prompt: options.generatedPrompt || "",
        edited_prompt: options.editedPrompt || "",
        prompt_source: options.promptChanged
          ? "user_edited"
          : "wizard_generated",
        auto_run: true,
        page: 1,
        updated_at: new Date().toISOString()
      };
    }

    function loadWizardOptions() {
      ReportsUiService.fetchMentions("", {
        fieldLimit: 1000,
        buildingLimit: 5000,
        userLimit: 5000
      })
        .then(function(res) {
          var data = res.data || {};
          vm.mentionData.buildings = data.buildings || [];
          vm.mentionData.users = data.users || [];
          vm.mentionData.fields = data.fields || [];
          vm.columnOptions = (data.fields || []).map(function(field) {
            return {
              id: field.id,
              name: field.name || field.id,
              category: field.category || "",
              value_type: field.value_type || inferValueType(field)
            };
          });
          vm.setDatePreset("ytd");
          vm.dateYearOptions = buildDateYearOptions(4);
          vm.dateQuarterOptions = buildDateQuarterOptions(6);
          vm.dateMonthOptions = buildDateMonthOptions(12);
          refreshDerivedFilterLists();
        })
        .catch(function() {
          vm.savedError = "Could not load report wizard options.";
        });

      var root = document.querySelector(
        ".dashboard-content[data-wizard-config]"
      );
      if (root) {
        try {
          var cfg = JSON.parse(root.getAttribute("data-wizard-config") || "{}");
          vm.availableForms = Array.isArray(cfg.forms) ? cfg.forms : [];
          var allowedTypes = Array.isArray(cfg.available_document_types)
            ? cfg.available_document_types
            : [];
          var labels = { Lease: "Lease", Amendment: "Amendment", Loi: "LOI" };
          vm.documentTypeOptions = allowedTypes.map(function(type) {
            return { id: type, name: labels[type] || type };
          });
          vm.standardColumnsView = Array.isArray(cfg.default_columns)
            ? cfg.default_columns
            : [];
        } catch (e) {
          vm.availableForms = [];
          vm.documentTypeOptions = defaultDocumentTypeOptions();
          vm.standardColumnsView = [];
        }
      } else {
        vm.documentTypeOptions = defaultDocumentTypeOptions();
        vm.standardColumnsView = [];
      }

      if (!vm.documentTypeOptions || vm.documentTypeOptions.length === 0) {
        vm.documentTypeOptions = defaultDocumentTypeOptions();
      }

      refreshDerivedFilterLists();
    }

    function defaultDocumentTypeOptions() {
      return [
        { id: "Lease", name: "Lease" },
        { id: "Amendment", name: "Amendment" },
        { id: "Loi", name: "LOI" }
      ];
    }

    function inferValueType(field) {
      var name = ((field && field.name) || "").toLowerCase();
      if (name.indexOf("date") >= 0 || name.indexOf("time") >= 0) return "date";
      if (
        name.indexOf("amount") >= 0 ||
        name.indexOf("rent") >= 0 ||
        name.indexOf("price") >= 0 ||
        name.indexOf("sqft") >= 0
      )
        return "number";
      return "string";
    }

    function stepValidationError(step) {
      if (
        step === 0 &&
        vm.wizard.useSpecificForms &&
        vm.wizard.formIds.length === 0
      )
        return "Select at least one form or turn off specific form filtering.";
      if (
        step === 1 &&
        vm.wizard.columnMode === "additional" &&
        vm.wizard.additionalColumns.length === 0
      )
        return "Select at least one additional column.";
      var hasAnyDate = !!vm.wizard.dateFrom || !!vm.wizard.dateTo;
      if (
        step === 2 &&
        hasAnyDate &&
        (!vm.wizard.dateFrom || !vm.wizard.dateTo)
      )
        return "Select both start and end dates or clear both.";
      if (
        step === 2 &&
        vm.wizard.dateFrom &&
        vm.wizard.dateTo &&
        vm.wizard.dateFrom > vm.wizard.dateTo
      )
        return "Start date must be before end date.";
      return "";
    }

    function snapshotFromWizard() {
      return {
        document_types: vm.wizard.documentTypes.slice(),
        date_preset: vm.wizard.datePreset || "",
        date_from: vm.wizard.dateFrom || "",
        date_to: vm.wizard.dateTo || "",
        user_ids: vm.wizard.userIds.slice(),
        building_ids: vm.wizard.buildingIds.slice(),
        form_ids: vm.wizard.useSpecificForms ? selectedConcreteFormIds() : [],
        columns:
          vm.wizard.columnMode === "additional"
            ? vm.wizard.additionalColumns.slice()
            : [],
        conditions: vm.wizard.conditions
          .filter(function(c) {
            if (!c.field_id) return false;
            if (c.operator === "empty" || c.operator === "not_empty")
              return true;
            return String(c.value).trim();
          })
          .map(function(c) {
            return {
              field_id: c.field_id,
              field_name: c.field_name,
              operator: c.operator || "eq",
              value:
                c.operator === "empty" || c.operator === "not_empty"
                  ? null
                  : c.value,
              value_type: c.value_type || "string"
            };
          })
      };
    }

    function normalizeStringArray(value) {
      if (value == null || value === "") return [];
      if (Array.isArray(value))
        return value
          .map(function(v) {
            return String(v);
          })
          .filter(Boolean);
      return String(value)
        .split(",")
        .map(function(v) {
          return v.trim();
        })
        .filter(Boolean);
    }

    function buildPromptFromWizard() {
      var pieces = ["Generate a report"];
      if (vm.wizard.documentTypes.length > 0) {
        pieces.push("for " + vm.wizard.documentTypes.join(" and "));
      }
      if (vm.wizard.buildingIds.length > 0) {
        pieces.push(
          "for buildings " +
            labelsFromIds(vm.wizard.buildingIds, vm.mentionData.buildings).join(
              ", "
            )
        );
      }
      if (vm.wizard.userIds.length > 0) {
        pieces.push(
          "created by " +
            labelsFromIds(vm.wizard.userIds, vm.mentionData.users).join(", ")
        );
      }
      if (vm.wizard.dateFrom && vm.wizard.dateTo) {
        pieces.push(
          "between " + vm.wizard.dateFrom + " and " + vm.wizard.dateTo
        );
      }
      if (
        vm.wizard.columnMode === "additional" &&
        vm.wizard.additionalColumns.length > 0
      ) {
        pieces.push(
          "with columns " +
            labelsFromIds(vm.wizard.additionalColumns, vm.columnOptions).join(
              ", "
            )
        );
      }
      if (vm.wizard.conditions.length > 0) {
        pieces.push(
          "where " +
            vm.wizard.conditions
              .filter(function(c) {
                if (!c.field_id) return false;
                if (c.operator === "empty" || c.operator === "not_empty")
                  return true;
                return String(c.value).trim();
              })
              .map(function(c) {
                if (c.operator === "empty")
                  return (c.field_name || c.field_id) + " is empty";
                if (c.operator === "not_empty")
                  return (c.field_name || c.field_id) + " is not empty";
                return (
                  (c.field_name || c.field_id) +
                  " " +
                  (c.operator || "eq") +
                  " " +
                  c.value
                );
              })
              .join("; ")
        );
      }
      if (vm.wizard.useSpecificForms && vm.wizard.formIds.length > 0) {
        pieces.push(
          "using forms " +
            vm.wizard.formIds
              .map(function(id) {
                var form = vm.availableForms.find(function(f) {
                  return String(f.id) === String(id);
                });
                return form
                  ? form.label || form.name || String(id)
                  : String(id);
              })
              .join(", ")
        );
      }
      return pieces.join(" ") + ".";
    }

    function ensurePromptReviewState() {
      var nextSnapshot = snapshotFromWizard();
      var prevSnapshot = vm.wizard.previewBefore;
      var selectionsChanged =
        !prevSnapshot ||
        JSON.stringify(prevSnapshot) !== JSON.stringify(nextSnapshot);

      vm.wizard.generatedPrompt = buildPromptFromWizard();

      if (selectionsChanged) {
        // Source selections changed, so prompt review should reflect latest wizard state.
        vm.wizard.editedPrompt = vm.wizard.generatedPrompt;
        vm.wizard.promptParseResult = null;
        vm.wizard.previewAfter = null;
      } else if (!vm.wizard.editedPrompt || !vm.wizard.editedPrompt.trim()) {
        vm.wizard.editedPrompt = vm.wizard.generatedPrompt;
      }

      vm.wizard.previewBefore = nextSnapshot;
    }

    function updatePromptMentionDropdown(target) {
      var text = vm.wizard.editedPrompt || "";
      var cursor =
        target && typeof target.selectionStart === "number"
          ? target.selectionStart
          : text.length;
      var before = text.substring(0, cursor);
      var match = before.match(/(?:^|\s)@([^\s@]*)$/);
      if (!match) {
        closePromptMentionDropdown();
        return;
      }
      var query = (match[1] || "").toLowerCase();
      vm.promptMentionStartPos = cursor - match[1].length - 1;
      vm.promptMentionCursorPos = cursor;
      vm.promptDropdownItems = buildPromptMentionItems(query);
      vm.promptDropdownOpen = vm.promptDropdownItems.length > 0;
      vm.promptHighlightedIndex = vm.promptDropdownOpen ? 0 : -1;
    }

    function buildPromptMentionItems(query) {
      var items = [];
      addPromptMentionItems(items, vm.mentionData.users, "user", query);
      addPromptMentionItems(items, vm.mentionData.buildings, "building", query);
      addPromptMentionItems(items, vm.columnOptions, "field", query);
      return items.slice(0, 12);
    }

    function addPromptMentionItems(items, source, type, query) {
      (source || []).forEach(function(raw) {
        var name = String(
          raw.name || raw.label || raw.email || raw.id || ""
        ).trim();
        if (!name) return;
        var id = String(raw.id || name);
        if (
          query &&
          name.toLowerCase().indexOf(query) < 0 &&
          id.toLowerCase().indexOf(query) < 0
        )
          return;
        items.push({
          key: type + "-" + id,
          type: type,
          type_label: type.charAt(0).toUpperCase() + type.slice(1),
          id: id,
          name: name
        });
      });
    }

    function closePromptMentionDropdown() {
      vm.promptDropdownOpen = false;
      vm.promptDropdownItems = [];
      vm.promptHighlightedIndex = -1;
      vm.promptMentionStartPos = -1;
      vm.promptMentionCursorPos = -1;
    }

    function labelsFromIds(ids, options) {
      return ids.map(function(id) {
        var option = (options || []).find(function(item) {
          return String(item.id) === String(id);
        });
        return option
          ? option.name || option.label || option.email || String(id)
          : String(id);
      });
    }

    function selectedConcreteFormIds() {
      var selected = vm.availableForms.filter(function(form) {
        return vm.wizard.formIds.indexOf(String(form.id)) >= 0;
      });

      var allIds = [];
      selected.forEach(function(form) {
        var ids =
          Array.isArray(form.form_ids) && form.form_ids.length > 0
            ? form.form_ids
            : [form.id];
        ids.forEach(function(id) {
          var strId = String(id);
          if (allIds.indexOf(strId) < 0) allIds.push(strId);
        });
      });
      return allIds;
    }

    function normalizeBooleanConditionValue(condition) {
      if (!condition) return;
      if (String(condition.value_type || "").toLowerCase() !== "boolean") return;
      if (
        condition.operator === "empty" ||
        condition.operator === "not_empty"
      ) {
        return;
      }
      var v = condition.value;
      if (v === true || v === "true") {
        condition.value = "true";
      } else if (v === false || v === "false") {
        condition.value = "false";
      } else {
        condition.value = "true";
      }
    }

    function ensureValidOperatorForCondition(condition) {
      if (!condition) return;
      var allowed = vm.operatorOptionsForCondition(condition).map(function(op) {
        return op.id;
      });
      if (allowed.indexOf(condition.operator) < 0) {
        condition.operator = allowed[0] || "eq";
      }
      normalizeBooleanConditionValue(condition);
    }

    function formsMatchingSelectedDocumentTypes() {
      if (!vm.wizard.documentTypes || vm.wizard.documentTypes.length === 0)
        return vm.availableForms;
      return vm.availableForms.filter(function(form) {
        return vm.wizard.documentTypes.indexOf(form.document_type) >= 0;
      });
    }

    function pruneSelectedFormsByDocumentTypes() {
      var allowed = formsMatchingSelectedDocumentTypes().map(function(form) {
        return String(form.id);
      });
      vm.wizard.formIds = vm.wizard.formIds.filter(function(id) {
        return allowed.indexOf(String(id)) >= 0;
      });
    }

    function toIsoDate(date) {
      var d = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      return d.toISOString().slice(0, 10);
    }

    function buildDateYearOptions(count) {
      var today = new Date();
      var years = [];
      for (var i = 0; i < count; i += 1) {
        var year = today.getFullYear() - i;
        years.push({ key: "year_" + year, label: String(year) });
      }
      return years;
    }

    function buildDateQuarterOptions(count) {
      var today = new Date();
      var currentQuarter = Math.floor(today.getMonth() / 3) + 1;
      var currentYear = today.getFullYear();
      var options = [];
      for (var i = 0; i < count; i += 1) {
        var quarterIndex = currentQuarter - i;
        var yearShift = 0;
        while (quarterIndex <= 0) {
          quarterIndex += 4;
          yearShift += 1;
        }
        var year = currentYear - yearShift;
        options.push({
          key: "quarter_" + year + "_q" + quarterIndex,
          label: "Q" + quarterIndex + " " + year
        });
      }
      return options;
    }

    function buildDateMonthOptions(count) {
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      var today = new Date();
      var options = [];
      for (var i = 0; i < count; i += 1) {
        var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        var keyMonth = String(d.getMonth() + 1);
        if (keyMonth.length < 2) keyMonth = "0" + keyMonth;
        options.push({
          key: "month_" + d.getFullYear() + "_" + keyMonth,
          label: monthNames[d.getMonth()] + " " + d.getFullYear()
        });
      }
      return options;
    }

    function apiErrorMessage(err, fallback) {
      if (err && err.data && err.data.errors && err.data.errors.join)
        return err.data.errors.join(" ");
      return fallback;
    }

    function focusInputById(id) {
      $timeout(function() {
        var input = document.getElementById(id);
        if (input) {
          input.focus();
          if (input.select) input.select();
        }
      }, 0);
    }

    function toggleInArray(arr, value) {
      var idx = arr.indexOf(value);
      if (idx >= 0) arr.splice(idx, 1);
      else arr.push(value);
    }

    function loadSavedReports() {
      vm.savedLoading = true;
      vm.savedError = "";
      ReportsUiService.fetchSavedReports()
        .then(function(res) {
          vm.savedReports = (res.data && res.data.saved_reports) || [];
        })
        .catch(function() {
          vm.savedError = "Could not load saved reports.";
        })
        .finally(function() {
          vm.savedLoading = false;
        });
    }

    vm.dismissToast = function dismissToast() {
      vm.toastVisible = false;
      vm.toastMessage = "";
      if (toastTimeoutPromise) {
        $timeout.cancel(toastTimeoutPromise);
        toastTimeoutPromise = null;
      }
    };

    function showToast(message, type, duration) {
      if (!message) return;
      vm.toastMessage = message;
      vm.toastType = type || "success";
      vm.toastVisible = true;
      if (toastTimeoutPromise) $timeout.cancel(toastTimeoutPromise);
      toastTimeoutPromise = $timeout(function() {
        vm.toastVisible = false;
        vm.toastMessage = "";
        toastTimeoutPromise = null;
      }, duration || 3500);
    }
  }
]);
